import { PaymentMethod } from '../../../../../../../../../../../services/exports/Constants';

export default {
  title: 'Payment methods',
  payment_options: {
    [PaymentMethod.Card]: 'Credit Card',
  },
};
